import React from 'react';
import './Carousel.css';

import videoUrl from '../../../assets/video/about-us.webm';

import logo from '../../../assets/images/PaperCactusLogo2.webp';
import logo_safari from '../../../assets/images/PaperCactusLogo2.png';

const AboutCarousel = () => {

  return (

    <div className="carousel">
      
      <video className="background-video" autoPlay loop muted>
        <source src={videoUrl} type="video/webm" />
      </video>
      <div className="overlay-content">
            <div className='page__header-title-aboutus'>
                <h1 style={{marginBottom: '-10px'}}>About Us</h1>
                <p style={{fontSize:'1.6rem'}}>Paper Cactus Games</p>
            </div>

            <div className='aboutus__general'>
              <picture>
                <source srcSet={logo} type='image/webp'/>
                <source srcSet={logo_safari} type='image/png'/>
                <img className="papercactus__aboutus-general-image" src={logo} alt="pc_logo"/>
              </picture>
              <div className='aboutus__general__text'>
                <p>Founded in 2022, Paper Cactus Games is an Australian based Indie Video Game Company. Paper Cactus Games aims to be a long term predominantly game studio based in Adelaide, Australia; with a focus on stylised games.<br/> <br/>We are developing innovative and engaging gameplay with a focus on the rogue-like video game genre. 
                We are a small but dedicated team aiming to become a permanent fixture in the Game Developer space. We have successfully funded 2 Kickstarter Projects as of 2025.
                </p>
              </div>
            </div>
      </div>
    </div>
  );
};

export default AboutCarousel;